import React, { useState, useEffect } from "react";
import AddNewEmployeePage from "../../../../../entities/DashboardPage/HRModule/Employees/Add";
import AuthService from "../../../../../api/AuthService";
import { useAlert } from "../../../../../context/AlertContext";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";

const AddNewEmployee = () => {
  const [data, setData] = useState("");
  const [imgUrl, setimgUrl] = useState("");
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [departmentData, setDepartmentData] = useState([]);
  const [payslip, setPayslip] = useState([]);
  const [document, setDocument] = useState([{ name: "", url: "" }]);
  const [userData, setUserData] = useState("")
  const [projectList, setProjectList] = useState([]);
  const [operatorData, setOperatorData] = useState([]);
  const [departmentLoaded, setDepartmentLoaded] = useState(false);
  const [operatorLoaded, setOperatorLoaded] = useState(false);

  useEffect(() => {
    getDepartment();
    getPayslipSetting();
    getProjectList();
    getOperators();
  }, [])

  const handleUrl = async (data) => {
    try {
      const result = await AuthService.handleSingleImgUrl(data);
      if (result) {
        setimgUrl(result?.data);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  }

  const CountryCode = async (country) => {
    try {
      const result = await AuthService.getCountry(country);
      if (result?.success) {

        setData(result?.data);
      } else {
        setData("");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleMultipleUrl = async (data, i) => {
    try {
      const result = await AuthService.handleSingleImgUrl(data);
      if (result) {
        showAlert(result?.message, "success");

        setDocument((prevItems) => {
          const updatedItems = [...prevItems];  // Create a shallow copy of the array

          while (updatedItems.length <= i) {
            updatedItems.push({ name: "", url: "" });
          }

          updatedItems[i].url = result?.data[0] || ""; // Assign the URL to the correct index
          updatedItems[i].name = data?.name || "";     // Assign the name to the correct index

          return updatedItems;
        });
      } else {
        // Handle the case where result is null or invalid
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const handleRegister = async (data, mobile, cCode, emergency, emergencyCode, workplace, workplaceCode) => {
    setLoading(true);
    try {
      const result = await AuthService.addNewEmploye(data, imgUrl, mobile, cCode, document, emergency, emergencyCode, workplace, workplaceCode);
      if (result?.success === true) {
        setLoading(false);
        setUserData(result?.data)
        showAlert(result?.message, "success")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");

      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };
  const getDepartment = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDepartment();
      if (result?.success) {
        setDepartmentData(result?.data?.position);
        setDepartmentLoaded(true);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getPayslipSetting = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayslipSetting();
      if (result?.success) {
        setPayslip(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getProjectList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getProjectList();
      if (result?.success) {
        setProjectList(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getOperators = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOperators(1, 100, true);
      if (result?.success) {
        const data =
          result?.data?.operator ||
          result?.data?.operators ||
          [];

        setOperatorData(data);
        setOperatorLoaded(true);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <AddNewEmployeePage departmentData={departmentData} operatorData={operatorData} document={document} setDocument={setDocument} loading={loading} data={data} CountryCode={CountryCode} registerEmployee={handleRegister} handleUrl={handleUrl} imgUrl={imgUrl} handleMultipleUrl={handleMultipleUrl} departmentLoaded={departmentLoaded} operatorLoaded={operatorLoaded} payslip={payslip} userData={userData} projectList={projectList}
    />
  )



};

export default AddNewEmployee;
